import React from 'react';
import {missionIcon, valuesIcon, visionIcon} from '../../../../assets/svg-icons';
// import {one} from '../../../../assets/home/mission-and-vision/one.js';
// import {two} from '../../../../assets/home/mission-and-vision/two.js';
// import {three} from '../../../../assets/home/mission-and-vision/three.js';
// import atob from 'atob';

import './styles.scss';
const OurStory = () => (
  <div className="our-story-section">
    <div className="our-story-info">
      <span className="bg-blue">HEXACT'S VISION</span>
      <h4>We build tools that do the work for you</h4>
      <p>
        Hexact&apos;s products are built around one idea: your time is better spent on decisions, not on collecting the
        data to make them.
      </p>
    </div>
    <div>
      <div className="d-flex info-section">
        <div className="img-section only-desktop">
          <img src='https://hexact.io/home/mission.png' alt="hexact-info-icon" />
        </div>
        <div className="text-section">
          <span>{missionIcon}</span>
          <h5 className="m-0">Hexact Mission</h5>
          <div className="img-section only-mobile">
            <img src='https://hexact.io/home/mission.png' alt="hexact-info-icon" />
          </div>
          <p>
            We build tools that help businesses monitor the web, extract data, and organize knowledge with AI, so they can
            focus on making better decisions faster.
          </p>
        </div>
      </div>

      <div className="d-flex info-section">
        <div className="text-section">
          <span>{visionIcon}</span>
          <h5 className="m-0">Hexact Vision</h5>
          <div className="img-section only-mobile">
            <img src='https://hexact.io/home/vision.png' alt="hexact-info-icon" />
          </div>
          <p>
            We&apos;re building the default toolkit for data-driven businesses. Web monitoring, scraping, and AI-powered
            knowledge management under one roof.
          </p>
        </div>
        <div className="img-section only-desktop">
          <img src='https://hexact.io/home/vision.png' alt="hexact-info-icon" />
        </div>
      </div>

      <div className="d-flex info-section">
        <div className="img-section only-desktop">
          <img src='https://hexact.io/home/purpose.png' alt="hexact-info-icon" />
        </div>
        <div className="text-section">
          <span>{valuesIcon}</span>
          <h5 className="m-0">Hexact Purpose</h5>
          <div className="img-section only-mobile">
            <img src='https://hexact.io/home/purpose.png' alt="hexact-info-icon" />
          </div>
          <p>
            We make powerful tools accessible. From solo founders to growing teams, our products put web intelligence and
            AI within reach for everyone.
          </p>
        </div>
      </div>
    </div>
  </div>
);

export default OurStory;
